/**
 * Translates text from Polish to Ukrainian using a free translation API.
 * Uses MyMemory Translation API as primary, with LibreTranslate as fallback.
 */
export const translateText = async (text: string): Promise<string> => {
  try {
    const response = await fetch(
      `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=pl|uk`,
      {
        method: 'GET',
        headers: { Accept: 'application/json' },
      }
    );

    if (!response.ok) throw new Error('MyMemory API error');

    const data = await response.json();
    if (data.responseData?.translatedText) return data.responseData.translatedText;
    throw new Error('No translation in response');
  } catch (error) {
    console.error('[translate] MyMemory error:', error);

    try {
      const res = await fetch('https://libretranslate.de/translate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ q: text, source: 'pl', target: 'uk', format: 'text' }),
      });
      if (!res.ok) throw new Error('LibreTranslate API error');

      const json = await res.json();
      if (json.translatedText) return json.translatedText;
      throw new Error('No translation in fallback response');
    } catch (e) {
      console.error('[translate] LibreTranslate fallback error:', e);
      throw new Error('All translation services failed');
    }
  }
};
